import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Popper } from "@mui/material";

export const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
export const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const PopperCustom = (props) => {
  return (
    <Popper
      {...props}
      placement="bottom-start"
      disablePortal={true}
      sx={{
        // zIndex:99
        zIndex: 2000, position:"relative", 
      }}
      modifiers={[
        {
          name: "flip",
          enabled: false,
          options: {
            altBoundary: true,
            rootBoundary: "document",
            padding: 8,
          },
        },
      ]}
    />
  );
}